import { instance } from './config';

export const getRequests = () => {
   return instance.get('/request');
};

export const getRequestsById = (requestId) => {
   return instance.get('/request/id/' + requestId);
};

export const getRequestsByDate = (startDate, endDate, pageNumber) => {
   return instance.get('/request/dates', {
      params: {
         startDate: startDate,
         endDate: endDate,
         pageNumber: pageNumber,
      },
   });
};

export const getRequestsByDatesAndMisdn = (startDate, endDate, keySearch, keyValue, pageNumber) => {
   return instance.get('/request/dates_msisdn', {
      params: {
         startDate: startDate,
         endDate: endDate,
         keySearch: keySearch,
         keyValue: keyValue,
         pageNumber: pageNumber,
      },
   });
};

export const getRequestsByDatesAndMeter = (startDate, endDate, keySearch, keyValue, pageNumber) => {
   return instance.get('/request/dates_meter', {
      params: {
         startDate: startDate,
         endDate: endDate,
         keySearch: keySearch,
         keyValue: keyValue,
         pageNumber: pageNumber,
      },
   });
};

export const getRequestsByTransactionId = (transactionId) => {
   return instance.get('/request/transaction/' + transactionId);
};
